import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from '@michelin/central-provider';
import { Container, LoadingBounce } from '@michelin/acid-components';
import useUtils from 'hooks/useUtils';
import useCustomer from 'hooks/useCustomer';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import { ChangeLogEntities, DealerProfileLocation } from 'Types';
import { useLocationST } from 'hooks/useLocation';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import LocationPanel from './LocationPanel';

interface LocationDetailsProps {
  action: 'edit' | 'view' | 'add',
}

export function LocationDetails(props: LocationDetailsProps) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const permissions = usePermissionsSPP();
  const { subTitle } = useUtils();
  const history = useHistory();
  const locationQuery = useLocationST(stNumber);
  const customerQuery = useCustomer(stNumber);

  if (locationQuery.isLoading || customerQuery.isLoading || permissions.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;

  if (!permissions.allowsAction('location_information.read', true)) {
    history.push('/');
  }

  return (
    <>
      <PageTitle
        title={t('Location Information')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.locationInformation} />)}
      />
      <Container>
        <LocationPanel
          action={props.action}
          location={locationQuery.data || {} as DealerProfileLocation}
          customer={customerQuery.data}
        />
      </Container>
    </>
  );
}
